<div class="dialogTestMain">
  @if (!testStarted && !testFinished) {
    <button
      mat-button
      [mat-dialog-close]="true"
      class="close"
      >
      <img src="assets/delete_grey.svg" />
    </button>
  }
  <p mat-dialog-title class="dialogTestTitle">Device Test</p>
  @if (!testFinished) {
    <div mat-dialog-content>
      <p class="dialogTestText">
        Please press 5s minimum and 1mn max the button underneath device
        {{ data.deviceId }}.
      </p>
    </div>
  }
  @if (!testStarted && !testFinished) {
    <div>
      <img src="assets/clock.png" />
    </div>
  }
  @if (testStarted && !testFinished) {
    <div>
      <div class="loader">
        <p>{{ 10 - intervalStep }}s</p>
      </div>
    </div>
  }
  @if (testFinished && !testFailed) {
    <div mat-dialog-content>
      <img src="assets/test_valid.png" />
      <p class="dialogTestText">Test successful</p>
    </div>
  }
  @if (testFinished && testFailed) {
    <div mat-dialog-content>
      <img src="assets/warning.png" />
      <p class="dialogTestTextError">Test error</p>
    </div>
  }
  <div mat-dialog-actions>
    @if (!testStarted && !testFinished) {
      <button
        mat-button
        (click)="startTest()"
        class="dialogTestBtn"
        >
        Start
      </button>
    }
    @if (testFinished) {
      <button
        mat-button
        #finish
        [mat-dialog-close]="false"
        class="dialogTestBtn"
        cdkFocusRegionstart
        >
        Ok
      </button>
    }
  </div>
</div>
